export const authUrl = "https://core.copima.ma";
